import { getSearchParamsForUpsell } from './get-search-params-for-upsell';

export const calculateUpsellLink = (
  srcInternal: string,
  isVideoLayout: boolean,
  shouldIncludePlan = false
) => {
  const params: { [key: string]: string } = isVideoLayout
    ? {
        from: 'video',
        src_internal: srcInternal,
      }
    : {
        from: 'settings',
        src_internal: srcInternal,
      };

  if (shouldIncludePlan) {
    params.plan = isVideoLayout ? 'pro' : 'basic';
  }

  return `/checkout${getSearchParamsForUpsell(params)}`;
};
